import { Action, createReducer, on } from '@ngrx/store';
import { LookupFieldResult } from '@wdx/clmi/clmi-swagger-gen';
import { CrudStateObject } from '@wdx/clmi/api-services/models';
import * as lookupsActions from './lookups.actions';

export const FEATURE_KEY = 'lookups';

export interface State {
    lookups: CrudStateObject<LookupFieldResult>;
}

export const initialState: State = {
    lookups: {},
};

const reducerSetup = createReducer(
    initialState,

    on(
        lookupsActions.getLookup,
        lookupsActions.getContextualLookup,
        (state, props): State => ({
            ...state,
            lookups: {
                ...state.lookups,
                [props.lookupId]: {
                    ...(state.lookups[props.lookupId] ||
                        ({} as CrudStateObject<LookupFieldResult>)),
                    isLoadingList: true,
                    hasLoadingListError: false,
                },
            },
        }),
    ),

    on(
        lookupsActions.getLookupSuccess,
        lookupsActions.getContextualLookupSuccess,
        (state, props): State => ({
            ...state,
            lookups: {
                ...state.lookups,
                [props.lookupId]: {
                    ...state.lookups[props.lookupId],
                    isLoadingList: false,
                    hasLoadingListError: false,
                    list: props.results,
                },
            },
        }),
    ),

    on(
        lookupsActions.getLookupFailure,
        lookupsActions.getContextualLookupFailure,
        (state, props): State => ({
            ...state,
            lookups: {
                ...state.lookups,
                [props.lookupId]: {
                    ...state.lookups[props.lookupId],
                    isLoadingList: false,
                    hasLoadingListError: true,
                },
            },
        }),
    ),

    on(
        lookupsActions.clearLookup,
        (state, props): State => ({
            ...state,
            lookups: {
                ...state.lookups,
                [props.lookupId]: {
                    ...(state.lookups[props.lookupId] ||
                        ({} as CrudStateObject<LookupFieldResult>)),
                    list: [],
                },
            },
        }),
    ),
);

export function reducer(state: State | undefined, action: Action) {
    return reducerSetup(state, action);
}
